export type PriceCurrency = "IDR" | "MYR";

export const configPrice: { [x: string]: any } = {
  IDR: {
    locales: "id",
    prefix: "Rp"
  },
  MYR: {
    locales: "en-MY",
    prefix: "RM"
  }
};

export const COUNTRY_CURRENCY: Record<string, PriceCurrency> = {
  ID: "IDR",
  MY: "MYR"
};

export const COUNTRY_NUMBER_LOCALE: Record<string, string> = {
  ID: "id-ID",
  MY: "en-MY"
};

const DEFAULT_CURRENCY: PriceCurrency = "IDR";
const DEFAULT_NUMBER_LOCALE = "id-ID";

export function getCurrencyByCountryCode(countryCode: string): PriceCurrency {
  const code = (countryCode ?? "").toUpperCase();
  return COUNTRY_CURRENCY[code] ?? DEFAULT_CURRENCY;
}

export function getNumberLocaleByCountryCode(countryCode: string): string {
  const code = (countryCode ?? "").toUpperCase();
  return COUNTRY_NUMBER_LOCALE[code] ?? DEFAULT_NUMBER_LOCALE;
}
